import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Grid, Card, CardContent, Typography, Button, Chip, List, ListItem, ListItemIcon, ListItemText
} from '@mui/material';
import { CheckCircle as CheckIcon, ArrowForward as ArrowIcon } from '@mui/icons-material';
import { getModuleById } from '../config/accountingModules';

const ModuleHub = ({ moduleId, children, showFeatures = true }) => {
  const navigate = useNavigate();
  const module = getModuleById(moduleId);

  if (!module) {
    return <Typography color="error">Module not found</Typography>;
  }

  return (
    <Box>
      <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
        <Box
          sx={{
            width: 56, height: 56, borderRadius: 2,
            bgcolor: module.color, display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 28
          }}
        >
          {module.icon}
        </Box>
        <Box sx={{ flex: 1 }}>
          <Typography variant="h4" fontWeight={600}>{module.title}</Typography>
          <Typography color="text.secondary">Accounting module management</Typography>
        </Box>
        <Button variant="outlined" onClick={() => navigate('/accounting')}>
          Back to Accounting
        </Button>
      </Box>

      <Grid container spacing={3} sx={{ mb: 3 }}>
        {module.subPages.map((page) => (
          <Grid item xs={12} sm={6} md={4} key={page.path}>
            <Card
              sx={{ cursor: 'pointer', transition: '0.2s', '&:hover': { transform: 'translateY(-2px)', boxShadow: 4 } }}
              onClick={() => navigate(page.path)}
            >
              <CardContent sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Typography fontWeight={500}>{page.label}</Typography>
                <ArrowIcon color="action" />
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {children}

      {showFeatures && !children && (
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>Module Features</Typography>
            <List dense>
              {module.features.map((feature, i) => (
                <ListItem key={i}>
                  <ListItemIcon sx={{ minWidth: 36 }}>
                    <CheckIcon color="success" fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary={feature} />
                </ListItem>
              ))}
            </List>
            <Chip label="Fully integrated with Sun System ERP" color="primary" variant="outlined" sx={{ mt: 2 }} />
          </CardContent>
        </Card>
      )}
    </Box>
  );
};

export default ModuleHub;
